import {baseStagingConfig} from '../base/staging.config';
import {cbsnewsQaConfig} from './qa.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbsnewsDecoStagingConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseStagingConfig, cbsnewsQaConfig, {
  environmentName: "Cbs News Deco Staging Environment",
  ionicEnvName: 'staging',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbsnews/staging.deco.config.ts